module.exports = __webpack_public_path__ + "static/media/sq_paxel.4572bda5.png";